var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3px",
    height: "11px",
    viewBox: "0 0 3 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-310.000000, -141.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5606017,12.4078894 C11.1461365,13.0032284 11.1461365,13.9712224 10.5606017,14.5688337 C9.96616152,15.1437221 9.03331338,15.1437221 8.43887316,14.5688337 C7.85333841,13.9712224 7.85333841,13.0009561 8.44109953,12.4056171 C9.02663428,11.8080058 9.97729336,11.8080058 10.5606017,12.4078894 Z M10.5450172,4.43443664 C10.556149,4.44352579 10.5650545,4.45488722 10.5739599,4.46397636 C10.858935,4.77755188 11.0125544,5.19110799 10.9991962,5.61829782 C10.9991962,6.00913107 10.404756,8.92447443 10.2221938,11.0467899 L8.80845023,11.0467899 C8.63924627,8.92447443 8.00250506,6.00913107 8.00250506,5.61829782 C7.99137322,5.19110799 8.14276624,4.77755188 8.42551496,4.46397636 C9.00214423,3.85727591 9.95280331,3.8436422 10.5450172,4.43443664 Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.c43bffa928003883a8a9cad129865817.svg";
export { ForwardRef as ReactComponent };